import React, { useEffect, useRef } from "react";
import { TravellerDropdownWrap, TravellerItem } from "./ContextEdit.styles";

const MAX_TRAVELLERS = 20;

interface TravellerDropdownProps {
  dropdownRef: React.RefObject<HTMLDivElement>;
  count: number;
  onSelect: (num: number) => void;
}

const TravellerDropdown: React.FC<TravellerDropdownProps> = ({
  dropdownRef,
  count,
  onSelect,
}) => {
  const scrolledRef = useRef(false);

  useEffect(() => {
    if (scrolledRef.current) return;
    const el = document.querySelector('[data-selected="true"]');
    if (el) {
      el.scrollIntoView({ block: "center", behavior: "auto" });
      scrolledRef.current = true;
    }
  }, []);

  return (
    <TravellerDropdownWrap
      ref={dropdownRef}
      onClick={(e) => e.stopPropagation()}
    >
      {Array.from({ length: MAX_TRAVELLERS }, (_, i) => i + 1).map((num) => (
        <TravellerItem
          key={num}
          data-selected={count === num}
          $isSelected={count === num}
          onClick={() => onSelect(num)}
        >
          {num <= 9 ? `0${num}` : num}
        </TravellerItem>
      ))}
    </TravellerDropdownWrap>
  );
};

export default TravellerDropdown;
